export const ENERGY_PICKUP_FEEDBACK_CONFIG = {
  basePath: "/assets/pack_11_champion_energy_sync_fx/",
  frameWidth: 512,
  frameHeight: 512,

  assets: {
    wolfSprintUp: {
      key: "pack11.wolf_sprint_up",
      animationKey: "wolf_sprint_up_pack11",
      file: "wolf_sprint_up_24f_sheet.png",
      frames: 24,
      fps: 20,
      repeat: -1
    },
    wolfChampionSurgeOverlay: {
      key: "pack11.wolf_champion_surge_overlay",
      animationKey: "wolf_champion_surge_overlay",
      file: "wolf_champion_surge_overlay_16f_sheet.png",
      frames: 16,
      fps: 18,
      repeat: 0
    },
    wolfSpeedStreakOverlay: {
      key: "pack11.wolf_speed_streak_overlay",
      animationKey: "wolf_speed_streak_overlay",
      file: "wolf_speed_streak_overlay_12f_sheet.png",
      frames: 12,
      fps: 18,
      repeat: 0
    },
    wolfPickupFlash: {
      key: "pack11.wolf_pickup_flash",
      animationKey: "wolf_pickup_flash",
      file: "wolf_pickup_flash_12f_sheet.png",
      frames: 12,
      fps: 24,
      repeat: 0
    },
    championCoreIdle: {
      key: "pack11.champion_core_idle",
      animationKey: "champion_core_idle",
      file: "champion_core_idle_24f_sheet.png",
      frames: 24,
      fps: 16,
      repeat: -1
    },
    championCorePickupBurst: {
      key: "pack11.champion_core_pickup_burst",
      animationKey: "champion_core_pickup_burst",
      file: "champion_core_pickup_burst_12f_sheet.png",
      frames: 12,
      fps: 24,
      repeat: 0
    },
    championShardIdle: {
      key: "pack11.champion_shard_idle",
      animationKey: "champion_shard_idle",
      file: "champion_shard_idle_16f_sheet.png",
      frames: 16,
      fps: 12,
      repeat: -1
    },
    energyTrailOrb: {
      key: "pack11.energy_trail_orb",
      animationKey: "energy_trail_orb",
      file: "energy_trail_orb_12f_sheet.png",
      frames: 12,
      fps: 12,
      repeat: -1
    },
    pressureCoreIdle: {
      key: "pack11.pressure_core_idle",
      animationKey: "pressure_core_idle",
      file: "pressure_core_idle_16f_sheet.png",
      frames: 16,
      fps: 12,
      repeat: -1
    },
    packEchoCoreIdle: {
      key: "pack11.pack_echo_core_idle",
      animationKey: "pack_echo_core_idle",
      file: "pack_echo_core_idle_16f_sheet.png",
      frames: 16,
      fps: 12,
      repeat: -1
    }
  },

  scale: {
    energyTrailOrb: 0.18,
    championShard: 0.22,
    championCore: 0.28,
    pressureCore: 0.25,
    packEchoCore: 0.25,
    pickupBurst: 0.45,
    wolfSurgeOverlay: 0.85,
    speedStreakOverlay: 0.85,
    pickupFlash: 0.45
  },

  offsets: {
    wolfSurgeOverlay: { x: 0, y: 0 },
    speedStreakOverlay: { x: 0, y: 40 },
    pickupFlash: { x: 0, y: 0 },
    pickupBurst: { x: 0, y: 0 }
  }
} as const;
